var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("MyToolbarVuetify", {
        ref: "myToolbarForm",
        staticClass: "bk_toolbar_fixed-top",
        on: { "button-click": _vm.toolbarButtonForm_Click }
      }),
      _c("div", { staticClass: "bk_firstBlock" }),
      _c("MyFormPanel", {
        ref: "form",
        attrs: { "data-source": _vm.formData }
      }),
      _c("h1", [_vm._v("頁面")]),
      _c("MyToolbarVuetify", {
        ref: "myToolbar",
        attrs: { "grid-select-ids": _vm.gridSelectIds },
        on: { "button-click": _vm.toolbarButton_Click }
      }),
      _c("MyVueEasytable", {
        ref: "grid",
        on: { "grid-selected": _vm.grid_Selected }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }